/* eslint-disable no-restricted-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */

import * as store from 'react-redux';

const { useSelector: nomatter, ...reactReduxRest } = store;
export const reactRedux = {
  ...reactReduxRest,
};

export type { Draft } from 'immer';

export { createSlice } from '@reduxjs/toolkit';

export type {
  PayloadAction,
  AnyAction,
  CaseReducer,
  SliceCaseReducers,
  Slice,
} from '@reduxjs/toolkit';

export { shallowEqual } from 'react-redux';

export { StoreProvider, injectReducers } from './store';

export * as reduxjsToolkit from '@reduxjs/toolkit';
